import { createContext as e, useContext as t, useState as n } from "react";
import { css as r, styled as i } from "styled-components";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/Tabs/Tabs.tsx
var s = e({ active: "" }), c = i.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`, l = i.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.5)};
    flex-shrink: 0;

    /* A row of tabs outgrows a phone: it scrolls sideways rather than overflowing the page. */
    @media (max-width: 768px) {
        max-width: 100%;
        overflow-x: auto;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
`, u = {
	sm: {
		px: "10px",
		py: "6px",
		font: "sm"
	},
	md: {
		px: "14px",
		py: "8px",
		font: "sm"
	},
	lg: {
		px: "18px",
		py: "10px",
		font: "base"
	}
}, d = i.button`
    display: inline-flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.75)};
    border: none;
    cursor: pointer;
    white-space: nowrap;
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e, $size: t }) => e.typographyTokens.sizes[u[t].font]};
    font-weight: ${({ theme: e, $active: t }) => t ? e.typographyTokens.weights.semibold : e.typographyTokens.weights.medium};
    padding: ${({ $size: e }) => `${u[e].py} ${u[e].px}`};
    transition: all ${({ theme: e }) => e.transitions.fast};
    position: relative;
    flex: ${({ $fullWidth: e }) => e ? "1" : "initial"};
    justify-content: center;

    /* Soft nav-pill — mirrors the active state of the floating navigation items. */
    border-radius: ${({ theme: e }) => e.radii.lg};
    color: ${({ theme: e, $active: t }) => t ? e.colors.primary : e.colors.mutedForeground};
    background: ${({ theme: e, $active: t }) => t ? `${e.colors.primary}18` : "transparent"};

    &:hover:not(:disabled) {
        ${({ theme: e, $active: t }) => !t && r`
                background: ${e.colors.accent};
                color: ${e.colors.foreground};
            `}
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`, f = i.span`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`, p = i.span`
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: ${({ theme: e }) => e.radii.full};
    background: ${({ theme: e }) => e.colors.destructive};
    color: ${({ theme: e }) => e.colors.destructiveForeground};
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
`, m = i.div`
    padding-top: ${({ theme: e }) => e.spacing(2)};
    width: 100%;
`, h = ({ value: e, children: n, className: r }) => {
	let { active: i } = t(s);
	return i === e ? /* @__PURE__ */ a("div", {
		role: "tabpanel",
		className: r,
		children: n
	}) : null;
}, g = ({ tabs: e, value: t, defaultValue: r, onChange: i, size: u = "md", children: h, className: g, fullWidth: _ = !1 }) => {
	let v = e.find((e) => !e.disabled)?.value ?? e[0]?.value ?? "", [y, b] = n(r ?? v), x = t ?? y, S = (e) => {
		t === void 0 && b(e), i?.(e);
	};
	return /* @__PURE__ */ a(s.Provider, {
		value: { active: x },
		children: /* @__PURE__ */ o(c, {
			className: g,
			children: [/* @__PURE__ */ a(l, {
				role: "tablist",
				children: e.map((e) => /* @__PURE__ */ o(d, {
					role: "tab",
					$active: x === e.value,
					$size: u,
					$fullWidth: _,
					disabled: e.disabled,
					"aria-selected": x === e.value,
					"aria-controls": `panel-${e.value}`,
					onClick: () => !e.disabled && S(e.value),
					children: [
						e.icon && /* @__PURE__ */ a(f, { children: e.icon }),
						e.label,
						e.badge !== void 0 && /* @__PURE__ */ a(p, { children: e.badge })
					]
				}, e.value))
			}), typeof h == "function" ? /* @__PURE__ */ a(m, { children: h(x) }) : h ? /* @__PURE__ */ a(m, { children: h }) : null]
		})
	});
};
//#endregion
export { h as TabPanel, g as Tabs };
